module.exports = __webpack_public_path__ + "img/en.dc797c10.svg";